console.log("\n%c Smart Investor", "color:#fff;font-size:12px; padding:0.45rem 0.75rem; margin: 0rem auto 1rem auto; font-family: Helvetica, sans-serif; border: 2px solid #0dd8d8; border-radius: 4px;font-weight: 100;background-size: cover;background-repeat: no-repeat;border: double 1px transparent;background-image: linear-gradient(#282828, #282828), radial-gradient(circle at top left, #2563EB, #82a0e2);background-origin: border-box;background-clip: padding-box, border-box;")

/*------------------------------------------------------------------ 
Import styles
------------------------------------------------------------------*/

import '../styles/main.scss';

/*------------------------------------------------------------------ 
Import scripts
------------------------------------------------------------------*/

import { down, up } from 'slide-element';
import { $, $$ } from '@/utilities/helpers';
import { StickyHeader } from '@/components/sticky-header';

import '@/directives/focus';

/*------------------------------------------------------------------
Start the app
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {
    /*------------------------------------------------------------------
    Sticky header animations
    ------------------------------------------------------------------*/

    if ($('.header')) setTimeout(() => new StickyHeader($('.header')), 500);

    /*------------------------------------------------------------------
    Mega menu interactions
    ------------------------------------------------------------------*/

    $('.js-toggle-search-links')
        ?.addEventListener('click', (e) => {
            e.preventDefault();
            document.body.classList.toggle('search-links-active');
        });

    /*------------------------------------------------------------------
    Mega menu interactions
    ------------------------------------------------------------------*/

    const megaMenuTrigger = $('.js-toggle-mega-menu');
    const megaMenu = $('#navigation');
    const megaMenuItems = megaMenu ? Array.from(megaMenu.querySelectorAll('.mega-menu__link')) : [];

    // Roving tabindex: only the active item is a tab stop, the rest are removed from tab order
    const focusMegaMenuItem = item => {
        megaMenuItems.forEach(i => i.setAttribute('tabindex', i === item ? '0' : '-1'));
        item.focus();
    };

    const openMegaMenu = () => {
        document.body.classList.add('mega-menu-active');
        megaMenuTrigger.setAttribute('aria-expanded', 'true');
        focusMegaMenuItem(megaMenuItems[0]);
    };

    const closeMegaMenu = ({ returnFocus = false } = {}) => {
        document.body.classList.remove('mega-menu-active');
        megaMenuTrigger.setAttribute('aria-expanded', 'false');
        if (returnFocus) megaMenuTrigger.focus();
    };

    if (megaMenuTrigger && megaMenu && megaMenuItems.length) {
        megaMenuTrigger.addEventListener('click', e => {
            e.preventDefault();
            document.body.classList.contains('mega-menu-active') ? closeMegaMenu() : openMegaMenu();
        });

        megaMenuTrigger.addEventListener('keydown', e => {
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                openMegaMenu();
            } else if (e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                document.body.classList.contains('mega-menu-active') ? closeMegaMenu({ returnFocus: true }) : openMegaMenu();
            }
        });

        megaMenuItems.forEach((item, index) => {
            item.addEventListener('keydown', e => {
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    focusMegaMenuItem(megaMenuItems[index + 1] || megaMenuItems[0]);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    focusMegaMenuItem(megaMenuItems[index - 1] || megaMenuItems[megaMenuItems.length - 1]);
                } else if (e.key === 'Home') {
                    e.preventDefault();
                    focusMegaMenuItem(megaMenuItems[0]);
                } else if (e.key === 'End') {
                    e.preventDefault();
                    focusMegaMenuItem(megaMenuItems[megaMenuItems.length - 1]);
                } else if (e.key === 'Escape') {
                    e.preventDefault();
                    closeMegaMenu({ returnFocus: true });
                }
            });
        });

        // Close the menu once focus moves outside both the trigger and the menu items
        document.addEventListener('focusout', e => {
            if (!document.body.classList.contains('mega-menu-active')) return;

            const nextFocus = e.relatedTarget;
            const staysInMenu = nextFocus && (nextFocus === megaMenuTrigger || megaMenu.contains(nextFocus));

            if (!staysInMenu) closeMegaMenu();
        });
    }

    /*------------------------------------------------------------------
    Intersection observers for animation styles
    ------------------------------------------------------------------*/

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('inview');
            }
        });
    }, {
        root: null, // Use the viewport as the root
        rootMargin: '-5% 0px' // Trigger when the element is in the middle of the page
    });

    // Add the observer to all elements with the class `js-inview`
    setTimeout(() => $$('.js-inview').forEach(element => observer.observe(element)), 10);

    import('@/components/table-accordion')
        .then(module => $$('.js-table-accordion-item').forEach(element => new module.TableAccordion(element)))
        .catch(error => console.error("Table Accordion component failed to load", error));

    /*------------------------------------------------------------------
    Accordion Elements
    ------------------------------------------------------------------*/

    const accordionElements = $$('.js-accordion-element');

    if (accordionElements.length) {
        import('@/components/accordion')
            .then(module => accordionElements.forEach(element => new module.Accordion(element, down, up)))
            .catch(error => console.error("Accordion component failed to load", error));
    }


    /*------------------------------------------------------------------
    Searchable investments Elements
    ------------------------------------------------------------------*/

    if ($('.js-searchable-table')) {
        import('@/components/searchable-investments')
            .then(module => $$('.js-searchable-table').forEach(element => new module.SearchableInvestments(element)))
            .catch(error => console.error("Searchable Investments component failed to load", error));
    }

    /*------------------------------------------------------------------
    Video Elements
    ------------------------------------------------------------------*/

    if ($('.js-video-element')) {
        import('@/components/video')
            .then(module => $$('.js-video-element').forEach(element => new module.Video(element)))
            .catch(error => console.error("Video component failed to load", error));
    }


    /*------------------------------------------------------------------
    Dialog Elements
    ------------------------------------------------------------------*/

    window.dialogs = [];

    const dialogElements = $$('.js-dialog-trigger');
    if (dialogElements.length) {
        import('@/components/dialogs')
            .then(module => dialogElements.forEach(element => window.dialogs.push(new module.Dialog(element))))
            .catch(error => console.error("Dialog component failed to load", error));
    }

    /*------------------------------------------------------------------
    Post Load classname removal:
    This removes the class `js-postload` from elements after the page 
    has loaded, to prevent any unwanted animations.
    ------------------------------------------------------------------*/

    $$('.js-postload').forEach(element => element.classList.remove('js-postload'));


    /*------------------------------------------------------------------
    Scroll to sections of the site with animations
    ------------------------------------------------------------------*/
    let $scrollToTriggers = $$('.js-scroll-to-section');

    $scrollToTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            let section = trigger.dataset.section;

            let $targetSection = $(`.js-section[id="${section}"]`);

            if ($targetSection) {
                $targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            } else {
                console.warn(`Section with ID ${section} not found.`);
            }

        });
    });

    /*------------------------------------------------------------------
    Scroll to sections of the site with animations
    ------------------------------------------------------------------*/
    let $anchorLinks = $$('.js-anchor-link');

    $anchorLinks.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            let link = trigger.href;
            let section = link.substring(link.indexOf('#') + 1);
            let $targetSection = $(`#${section}`);

            if ($targetSection) {
                $targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            } else {
                console.warn(`Section with ID ${section} not found.`);
            }

        });
    });

    /*------------------------------------------------------------------
    Social share modal
    ------------------------------------------------------------------*/
    let $printAction = $$('.js-print-page');

    $printAction.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();

            window.print();
        });
    });

    /*------------------------------------------------------------------
    Social share modal
    ------------------------------------------------------------------*/
    let $toggleShareModal = $$('.js-toggle-share-modal');

    $toggleShareModal.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();

            let $shareModal = trigger.nextElementSibling;

            if ($shareModal) {
                $shareModal.classList.toggle('active');
            } else {
                console.warn('Share modal not found.');
            }
        });
    });

    // on click outside the modal to close it
    document.addEventListener('click', (e) => {
        if (!e.target.closest('.js-toggle-share-modal') && !e.target.closest('.js-share-modal')) {
            $$('.js-share-modal.active').forEach(modal => modal.classList.remove('active'));
        }
    });

});

